import 'es6-promise/auto'
import Vue from 'vue'

new Vue({
    el: '#app',
    data: {
        result: [],
        current: {},
        year: ""
    },
    mounted: function () {
        if (window.data !== undefined) {
            this.result = window.data;
            if (this.year === "" && Object.keys(this.result).length > 0) {
                const keys = Object.keys(this.result).sort().reverse();
                this.year = keys[0];
                this.current = this.result[this.year];
            }
        }
    },
    watch: {
        year: function (value) {
            this.current = this.result[value];
        }
    },
    methods: {
        change: function () {
        }
    }
});
